import { authFetchDELETE, authFetchGET, authFetchPOST, authFetchPUT } from "../utils/auth-fetch";
import { Alarm, AlarmState, AlarmType, FleetAlarmAudience } from "./types/fleet-alarms-service.types";
import { fromDateMethod } from "../../local_modules/voy-fleet-sub-view/src/helper";

const env = (<any>window)["appenv"].services.alarms;

const configenv = (<any>window)["appenv"].services.configapi;

export class FleetAlarmsService {
    static async getAlarms(imo: number | null, includeLogs: boolean, includeDetections: boolean| true, excludeStates?: AlarmState[], aud?: FleetAlarmAudience, alarmTypes?: AlarmType[], fromDate?:string,toDate?:string): Promise<Alarm[]> {
        const baseQuery = `${env.baseurl}/alarms?`;
        let params = new URLSearchParams();
        
        if (aud) {
            params.set("aud", aud.toString())
        }

        if(imo){
            params.set("imo", imo.toString())
        }
        if (fromDate) {
            params.set("from", fromDate);
        }
    
        if (toDate) {
            params.set("to", toDate);
        }
        if (excludeStates) {
            const queryWithParameters = excludeStates?.reduce((prev, curr, idx) => {
                if (idx !== excludeStates.length - 1){
                    return prev + `${curr},`
                }
                return prev + curr
            }, '')
            params.set("excludeStates", queryWithParameters)
        } 

        if (includeLogs){
            params.set("include", 'logs')
            if(includeDetections) {
                params.set("include",'logs,detections')
            }
        }

        if (alarmTypes?.length) {
            // send it as a comma separated string
            const queryWithParameters = alarmTypes.reduce((prev, curr, idx) => {
                if (idx !== alarmTypes.length - 1){
                    return prev + `${curr},`
                }
                return prev + curr
            }, '')
            params.set("alarmType", queryWithParameters)
        }

        const query = baseQuery + params.toString()

        return await authFetchGET(env.scope, query) 
    }

    static async getAlarmByID(id: number): Promise<Alarm> {
        return await (authFetchGET(env.scope, `${env.baseurl}/alarms/${id}`))
    }

    static async updateAlarm(id: number, state: AlarmState, reason: string, note?: string, muteUntil?: string): Promise<void> {
        const requestBody = {
            note,
            reason,
            state,
            muteUntil
        }

        return await authFetchPUT(env.scope, `${env.baseurl}/alarms/${id}`, requestBody)
    }

    static async updateWeatherAlarm(id: number, state: AlarmState, reason: string, note?: string, muteUntil?: string): Promise<any> {
        const requestBody = {
            note,
            reason,
            state,
            muteUntil
        }

        return await authFetchPUT(env.scope, `${env.baseurl}/alarms/updateAlarm/${id}`, requestBody)
    }

    
    static async getCompanyWeatherLimits(): Promise<any> {
        return await (authFetchGET(env.scope, `${configenv.baseurl}/getweatherlimits`))
    }

    static async getCompanyWeatherLimitsHistory(isCustom:boolean): Promise<any> {
        if( isCustom) {
            return await (authFetchGET(env.scope, `${configenv.baseurl}/getcustomweatherlimitshistory/`))
        }
        return await (authFetchGET(env.scope, `${configenv.baseurl}/getweatherlimitshistory/`))
    }

    static async setCompanyWeatherLimits(data:any): Promise<any> {
        return await authFetchPOST(
          env.scope,
          `${configenv.baseurl}/saveweatherlimits`,
          data
        );
    }

    static async setCustomWeatherLimits(data:any): Promise<any> {
        return await authFetchPOST(
          env.scope,
          `${configenv.baseurl}/savecustomweatherlimit`,
          data
        );
    }

    static async getCustomWeatherLimits(): Promise<any> {
        return await (authFetchGET(env.scope, `${configenv.baseurl}/customweatherlimit?type=custom`))
    }

    static async getCustomWeatherLimitsByIMO(imoList: number[]): Promise<any> {
        return await (authFetchPOST(env.scope, `${configenv.baseurl}/customweatherlimit`,  imoList ))
    }

    static async deleteCustomWeatherLimits(imo: number): Promise<any> {
        return await authFetchDELETE(env.scope, `${configenv.baseurl}/deletecustomweatherlimit/${imo}`)
    }

}
